<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      d="M255.66,188.56h11.66q85.86,0,171.72,0c19.38,0,27.6,8.15,27.65,27.49q.1,40,0,80.07c-.05,19.36-8.2,27.3-27.77,27.3H255.66V334c0,27.88-.13,55.76.06,83.63.07,11-2.88,20-14,24.27-10.82,4.14-19.33.27-27.16-7.58Q135.1,354.61,55.4,275.14c-13.48-13.49-13.49-25.09-.22-38.34q79.65-79.52,159.35-159c6.16-6.16,12.85-10.6,22-9.11,12.19,2,19,10.27,19.08,23.94.2,28.18.07,56.35.08,84.53Z"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
